import IConfig from "./interfaces/config";

function getConfig(): IConfig {
    return process.env.NODE_ENV === "development"
        //  ? { url: "https://betatutorchat.uv.es" }
        ? { url: "http://localhost:8080" }
        : {url:""};
}

const AppConfig: IConfig = getConfig();

export default AppConfig;
